import { Directive, ElementRef, HostBinding, Input, OnInit, Optional } from "@angular/core";

import { ButtonLikeAbstraction } from "../shared/button-like.abstraction";

export const PrefixClasses = [
  // "tw-bg-background-alt",
  // "tw-border",
  // "tw-border-solid",
  // "tw-border-secondary-500",
  "tw-text-muted",
  // "tw-rounded-none",
];

export const PrefixButtonClasses = [
  "hover:tw-bg-text-muted",
  "hover:tw-text-contrast",
  "disabled:tw-opacity-50",
  "disabled:tw-bg-color-surface-sunken",
  "disabled:hover:tw-bg-color-surface-sunken",
  "disabled:hover:tw-text-muted",
];

/**
 * Keyboard focus for any prefix/suffix <button> - a bitIconButton or a plain one, like the password
 * visibility toggle on login, lock and register: the house :focus-visible outline (base.scss),
 * drawn inside the button. It sits flush against the input's edge, so an outward outline would
 * land on the input's own border.
 */
export const PrefixFocusClasses = ["focus-visible:-tw-outline-offset-2"];

export const PrefixStaticContentClasses = ["tw-block", "tw-px-3", "tw-py-1.5"];

/** The classes a prefix/suffix host gets for its kind: a button-like component or static content. */
export function prefixContentClasses(
  host: HTMLElement,
  buttonComponent: ButtonLikeAbstraction | null,
): string[] {
  return (buttonComponent != undefined ? PrefixButtonClasses : PrefixStaticContentClasses).concat(
    host.tagName === "BUTTON" ? PrefixFocusClasses : [],
  );
}

@Directive({
  selector: "[bitPrefix]",
})
export class BitPrefixDirective implements OnInit {
  constructor(
    private elementRef: ElementRef<HTMLElement>,
    @Optional() private buttonComponent: ButtonLikeAbstraction,
  ) {}

  @HostBinding("class") @Input() get classList() {
    return PrefixClasses.concat(["tw-border-r-0", "first:tw-rounded-l"]).concat(
      prefixContentClasses(this.elementRef.nativeElement, this.buttonComponent),
    );
  }

  ngOnInit(): void {
    this.buttonComponent?.setButtonType("unstyled");
  }
}
